/**
 * AMS Engagements Subscriptions Manager:
 * --------------------------------------
 * This class Responsible for "Sync" with the UMS whenever a engagement is opened.
 */
define(function (require) {

    var BaseController = require('web-agent-assets-js/BaseController');
    var lpAMSController = require('web-agent-assets-js/lpAMSController');
    var privilegesController = require('web-agent-assets-js/lpPrivilegesController');

    var MY_ENGAGEMENTS_PATH = 'participants.myEngagements';
    var lpWebAgentStatics = require('web-agent-assets-js/lpWebAgentStatics');
    var sdkCommunicationChannel = lpWebAgentStatics.COMMUNICATION_CHANNELS.SDK;

    var lpAMSEngagementsSubscriptionsManager = BaseController.extend(function AMSEngagementsSubscriptionsManager(options) {
        this.model = options.model;
        lpTag.WebAgent.channel.register(sdkCommunicationChannel.name, sdkCommunicationChannel.events.onUserProfileSetCompleted, handleUserProfileUpdate.bind(this));
    });
    lpAMSEngagementsSubscriptionsManager.prototype.applicationType = 'lpAMSEngagementsSubscriptionsManager';

    /**
     * Initializing the subscription manager for the engagements
     * will create new subscription if any open conversation exists.
     */
    lpAMSEngagementsSubscriptionsManager.prototype.start = function () {
        this.logger.debug('starting the subscription manager bindings.');

        // unbind all listeners and clear the subscriptions list
        this.stop();

        // binding to the my engagement to get all the data from the
        this.model.bind(MY_ENGAGEMENTS_PATH, onEngagementNotification, this);
    };

    /**
     * Initializing the subscription manager for the engagements
     * will create new subscription if any open conversation exists.
     */
    lpAMSEngagementsSubscriptionsManager.prototype.stop = function () {
        // this will unbind all active bindings to this class if exists.
        this.model.unbind(null, null, this);

        // resetting the engagement subscription object.
        this.engagementSubscriptions = {};
    };

    /**
     * Handle Engagement's Notification - contain data on the participant
     * @param data
     */
    function onEngagementNotification(data) {
        if (data && data.newValue && data.newValue) {
            for (var item in data.newValue) {
                if (data.newValue.hasOwnProperty(item)) {
                    handleEngagement(this, data.newValue[item]);
                }
            }
        }
    }

    /**
     * handle registration for single engagement, create specific bindings for the engagement when it's closing and
     * need to be listen on events.
     * @param context
     * @param engagement
     */
    function handleEngagement(context, engagement) {
        // only handle async messaging conversations.
        if (engagement && engagement.participantInfo && engagement.participantInfo.engagementType !== lpTag.WebAgent.logicController.engagementTypes.asyncMessaging) {
            return;
        }

        var consumerId = engagement && engagement.participantInfo && engagement.participantInfo.visitorId;
        if (!context.engagementSubscriptions.hasOwnProperty(consumerId)) {
            bindEngagementEvents();
        }

        // handle the state of the engagement
        function onEngagementStateChange(data) {
            if(!context.engagementSubscriptions.hasOwnProperty(consumerId)){
                createSubscription(context, consumerId);
            }
        }

        // as ums currently ignores the conversationId on the engagement subscription
        // the only way to respond to such changes it to 'refresh' the subscription by removing and recreating it
        function onEngagementActiveChatChange() {
                this.restartSubscriptionForConsumer(consumerId);
        }

        // handle the deletion of the engagement from myEngagements path
        function onEngagementChange(data) {
            // listen to the delete key.
            if (data && data.removedValue) {
                context.logger.debug('consumer engagement disposed for consumer:' + consumerId);
                // the engagement has been destroyed.
                unbindEngagementEvents();
                // removing any subscription if any.
                removeSubscription(context, consumerId);
            }
        }

        // bind to "Consumer" engagement events.
        function bindEngagementEvents() {
            context.logger.debug('creating bindings for consumerId:' + consumerId);
            context.model.bind(MY_ENGAGEMENTS_PATH + '.' + consumerId + '.participantState.engagementState', onEngagementStateChange, context);
            context.model.bind(MY_ENGAGEMENTS_PATH + '.' + consumerId + '.participantInfo.activeChat', onEngagementActiveChatChange, context);
            context.model.bind(MY_ENGAGEMENTS_PATH + '.' + consumerId, onEngagementChange, context);
        }

        // unbind from "Consumer" engagement events.
        function unbindEngagementEvents() {
            context.logger.debug('removing bindings for consumerId:' + consumerId);
            context.model.unbind(MY_ENGAGEMENTS_PATH + '.' + consumerId, onEngagementChange, context);
            context.model.unbind(MY_ENGAGEMENTS_PATH + '.' + consumerId + '.participantState.engagementState', onEngagementStateChange, context);
            context.model.unbind(MY_ENGAGEMENTS_PATH + '.' + consumerId + '.participantInfo.activeChat', onEngagementActiveChatChange, context);
        }
    }

    /**
     *
     * @param {*} params
     */
    lpAMSEngagementsSubscriptionsManager.prototype.restartSubscriptionForConsumer = function(consumerId) {
            removeSubscription(this, consumerId);
            createSubscription(this, consumerId);
    };

    /**
     * Handle user profile update- recreate the subscription for a specific consumer
     * @param requestObj
     */
    function handleUserProfileUpdate(requestObj) {
        if (requestObj && requestObj.consumerId) {
            this.restartSubscriptionForConsumer(requestObj.consumerId);
        }
    }

    /**
     * create a new subscription for the closed engagement.
     * @param context
     * @param consumerId
     */
    function createSubscription(context, consumerId) {
        var conversationId = context.model.get(MY_ENGAGEMENTS_PATH + '.' + consumerId + '.participantInfo.activeChat');

        var convState = lpTag.WebAgent.logicController.getConversationStateByChatId(conversationId);
        
        if(convState !== lpAMSController.CONVERSATION_STATES.OPEN) {
            return;
        }

        if (context.engagementSubscriptions[consumerId] && context.engagementSubscriptions[consumerId].conversationId === conversationId) {
            context.engagementSubscriptions[consumerId].abort = false;
            return;
        }

        context.logger.debug('creating subscription for consumer:' + consumerId + ' conversationId:' + conversationId);

        var consumerSubscription = context.engagementSubscriptions[consumerId] = {
            consumerId: consumerId,
            conversationId: conversationId
        };

        var query = {
            brandId: context.model.get('account'),
            consumerId: consumerId,
            conversationId: conversationId
        };

        var postProcessHandlers = getPostProcessHandlers(conversationId, consumerId, context);
        lpTag.WebAgent.amsSubscriptionsController.subscribe(query, {
            conversationPostProcessHandlers: postProcessHandlers.conversationPostProcessHandlers,
            onNotificationPostProcess:   postProcessHandlers.notificationPostProcessHanlder,
            trackActiveConversations: true  // Needed for the SLA calculation in the orb and editor
        }, onSubscriptionResponse);

        function onSubscriptionResponse(err, data) {
            if (err) {
                delete context.engagementSubscriptions[consumerId];
                context.logger.error('subscription creation failed for subscription key:' + consumerId);
                return;
            }
            context.logger.debug('subscription for consumer:' + consumerId + ' conversation: ' + conversationId + ' subscription:' + data.subscriptionId);
            consumerSubscription.subscriptionId = data.subscriptionId;

            if (consumerSubscription.abort) {
                removeSubscription(context, consumerId);
            }
        }
    }

    /**
     * removing a subscription of a specific consumer.
     * @param context
     * @param consumerId
     */
    function removeSubscription(context, consumerId) {
        if (context.engagementSubscriptions.hasOwnProperty(consumerId)) {
            var subscriptionId = context.engagementSubscriptions[consumerId].subscriptionId;
            context.logger.debug('removing subscription for engagement, subscriptionId:' + subscriptionId);
            if (subscriptionId) {
                lpTag.WebAgent.amsSubscriptionsController.unsubscribe(subscriptionId, context);
                delete context.engagementSubscriptions[consumerId];
            } else {
                context.engagementSubscriptions[consumerId].abort = true;
            }
        }
    }

    /**
     * get a scoped post process handlers for the subscription.
     * @param conversationId
     * @returns {{}}
     */
    function getPostProcessHandlers(conversationId, consumerId, context) {
        var handlers = {
            conversationPostProcessHandlers: {}
        };
        handlers.conversationPostProcessHandlers[lpAMSController.NOTIFICATION_TYPES.UPSERT] = handleSubscriptionUpdates;

        return handlers;

        function handleSubscriptionUpdates(conversationData) {
            // this is a temp solution, currently we have no way to track specific conversation so
            // we are filtering it in the UI.
            //TODO this logic should be extracted to conversationContrioller.getConversation that will return the conversation data
            if (conversationData && conversationData.convId === conversationId) {
                lpTag.WebAgent.amsConversationController.updateChatModelByConversation(conversationData);

                // If the conversation is Opened, Make sure that the current agent is in the participants list.
                var conversationState = conversationData.conversationDetails.stage || conversationData.conversationDetails.state;
                if (conversationState === lpAMSController.CONVERSATION_STATES.OPEN && lpTag.WebAgent.logicController.isInMyEngagements(conversationId)) {
                    var currentAgentId = lpTag.WebAgent.AppMediator.getModelParam('agent.messagingUserId');
                    ensureActiveParticipant(conversationData, currentAgentId, updateSubscriptionWithCurrentAgent.bind(context, currentAgentId));
                }
            }

            function ensureActiveParticipant(conversationData, currentAgentId, callback){
                // Searching for the current agent in the conversation, if not exist, add it as a reader.
                var activeDialog = getActiveDialog();
                var hasPermissionToJoin = hasPermissionToJoinAsReader(activeDialog);
                if(activeDialog && hasPermissionToJoin && !isParticipatingInTheConversation(activeDialog)){
                    // Register as "Reader" to the active dialog conversation to get updates.
                    lpTag.WebAgent.amsConversationController.addReaderParticipant({conversationId: conversationData.convId, dialogId: activeDialog.dialogId, success: function () {
                        callback();
                        lpTag.WebAgent.amsMessagesController.queryMessages(conversationData.convId);
                    }});
                } else {
                    callback();
                }

                function getActiveDialog() {
                    return _.find(conversationData.conversationDetails.dialogs, function(dialog) { return dialog.state === lpAMSController.CONVERSATION_STATES.OPEN; });
                }

                function hasPermissionToJoinAsReader(activeDialog) {
                    var retVal;
                    if (!activeDialog) {
                        retVal = false;
                    } else {
                        switch (activeDialog.dialogType) {
                            case lpAMSController.DIALOG_TYPES.MAIN:
                                retVal = true;
                                break;
                            case lpAMSController.DIALOG_TYPES.POST_SURVEY:
                                retVal = privilegesController.hasViewMessagingSurveysPrivilege();
                                break;
                            default:
                                retVal = false;
                                break;
                        }
                    }
                    return retVal;
                }

                function isParticipatingInTheConversation(activeDialog){
                    var retVal = false;
                    if (activeDialog.participantsDetails) { // new ums API format
                        _.each(activeDialog.participantsDetails, function (participant) {
                            if (participant.id === currentAgentId) {
                                retVal = true;
                            }
                        });
                    } else {
                        for(var participantRole in conversationData.conversationDetails.participants){
                            if(_.indexOf(conversationData.conversationDetails.participants[participantRole], currentAgentId) !== -1){
                                retVal = true;
                            }
                        }
                    }
                    return retVal;
                }
            }
        }

        function updateSubscriptionWithCurrentAgent(currentAgentId) {
            if( this.engagementSubscriptions[consumerId] && (!this.engagementSubscriptions[consumerId].agentIds || this.engagementSubscriptions[consumerId].agentIds[0] !== currentAgentId)) {
                var subscriptionId = this.engagementSubscriptions[consumerId].subscriptionId;
                this.engagementSubscriptions[consumerId].agentIds = [currentAgentId];
                lpTag.WebAgent.amsSubscriptionsController.updateSubscription(subscriptionId, {agentIds: [currentAgentId]});
            }
        }
    }

    return lpAMSEngagementsSubscriptionsManager;

});
